(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["card-product"] && !Shopify.designMode) return;
  try {
    document.querySelector('.product-card').addEventListener('animationend', function() {
    this.querySelector('.card-image-link.has-secondary').classList.add('animation-complete');
  });
  } catch(e) { console.error(e); }
})();

})();
